// D5 — informação complementar do denunciante, na tela do comitê.
// (docs/LEVANTAMENTO-CHAT-2026-07-28.md §D5)
//
// O denunciante tem DOIS campos de escrita na tela de status: "Responder ao comitê"
// (canal Div3) e "Enviar informação complementar". O servidor sempre entregou o
// segundo ao comitê, decifrável — mas nenhuma tela o renderizava. Este painel é o
// destinatário que faltava.
//
// POR QUE MORA NA ABA "DESCRIÇÃO", E NÃO NA ABA "MENSAGENS":
// `POST /api/status/info-complementar` **não é gateado** por
// `COMITE_MESSAGING_ENABLED` (só `/status/mensagem` é). O denunciante consegue
// enviar informação complementar com o canal de mensagens DESLIGADO. Pendurar este
// painel na aba "Mensagens" — que só existe quando a flag está ON — apagaria a
// informação exatamente na configuração em que ela é o ÚNICO caminho de volta que
// ele tem. Além disso é conteúdo da denúncia, não conversa: pertence ao relato.
//
// PRESENTACIONAL: recebe texto já decifrado. Toda a cripto vive no
// `withCaseDek` da CaseDetailPage (uma única abertura da DEK, junto do teor e dos
// pareceres) — este componente nunca vê DEK nem ciphertext.

import { useTranslation } from 'react-i18next';

export interface InfoComplementarItem {
  readonly ulid: string;
  readonly createdWeek: string;
  /** Texto já decifrado — ou o marcador de falha. NUNCA vazio por falha silenciosa. */
  readonly texto: string;
}

export function InfoComplementarPanel({
  itens,
}: {
  itens: ReadonlyArray<InfoComplementarItem>;
}): JSX.Element | null {
  const { t } = useTranslation();
  // Sem informação complementar não há bloco — nem título, nem moldura vazia.
  if (itens.length === 0) return null;

  return (
    <section className="review-section" data-testid="info-complementar-lista">
      {/* i18n do comitê represado: `defaultValue` entrega a copy correta agora e
          cede o lugar sozinho quando a chave entrar no pt-BR.json. */}
      <div className="review-label">
        {t('case_detail.info_complementar_title', {
          defaultValue: 'Informações complementares enviadas pelo denunciante',
        })}
      </div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {itens.map((item) => (
          <li key={item.ulid} data-testid="info-complementar-item" style={{ marginBottom: 8 }}>
            <div className="message">
              <div className="message-meta">{item.createdWeek}</div>
              <div style={{ whiteSpace: 'pre-wrap' }}>{item.texto}</div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
